<template>
<v-container>
  <v-card>
    <v-card-title>
      <v-row>
        
        <v-col cols="12" sm="6" md="2">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-btn color="primary" @click="createCSV()">
            <v-icon left dark>mdi-download</v-icon>Download
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-data-table :headers="headers" :fixed-header="true" :items="positions" :search="search" :footer-props="{
    'items-per-page-options': [10, 20, 30, 40, 50]
    }" :items-per-page="40" item-key="id" class="elevation-1" :loading="isLoading"
     loading-text="Loading... Please wait" @click:row="onRowClick($event)" :mobile-breakpoint="100">
      <template v-slot:item.train_date="{ item }">
        {{getFormattedDate(item.train_date)}}
      </template>
     </v-data-table>
  </v-card>
</v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import jsonexport from 'jsonexport/dist'
import {
  saveAs
} from 'file-saver';
import {
  mapState,
  mapGetter,
  mapActions
} from 'vuex'

export default {
  name: 'hog_trains',
  data() {
    return {
      csvurl: null,
      search: '',
      file: [],
      dateRules: [v => !!v || 'Date is required'],
      start_date: this.curStartDate || moment().add(-30, 'd').format('YYYY-MM-DD'),
      end_date: this.curEndDate || moment().format('YYYY-MM-DD'),
      startDateFormatted: this.curStartDate || moment().add(-30, 'd').format('DD/MM/YYYY'),
      endDateFormatted: this.curEndDate || moment().format('DD/MM/YYYY'),
      menu1: false,
      menu2: false,
      errors: [],
      headers: [
       {
          text: 'Division',
          align: 'left',
          value: 'division',
        },
        {
          text: 'Depot',
          align: 'left',
          value: 'depot',
        },
        {
          text: 'Train No',
          value: 'train_no'
        },
        {
          text: 'Train Name',
          value: 'train_name'
        },
        {
          text: 'Frequency',
          value: 'frequency'
        },
        {
          text: 'Org Stn',
          value: 'start'
        },
        {
          text: 'Destination',
          value: 'end'
        }
      ],
      position: {},
      positions: [],
      isLoading: false,
    }
  },
  created() {
    this.start_date = this.curStartDate || moment().add(-30, 'd').format('YYYY-MM-DD'),
      this.end_date = this.curEndDate || moment().format('YYYY-MM-DD'),
      this.getPositions()

    // axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
    // axios.get(`${process.env.VUE_APP_API_URL}/timetable/tc/events`,{params: p})
    // .then(response => {
    // //  console.log(response.data);
    //   this.positions = response.data
    // //  this.csvurl = this.createCSV()
    // })
    // .catch(e => {
    //   this.errors.push(e)
    //   if(e.response.status === 401) {
    //     this.$router.push({
    //       name: 'Signin'
    //     })
    //   }
    // })

  },
  computed: {
    ...mapState(['curStartDate', 'curEndDate', 'curCrewId']),
    computedDateFormatted() {
      return this.formatDate(this.editItem.train_date)
    },
  },
  watch: {

    start_date(val) {
      this.startDateFormatted = this.formatDate(val)
    },
    end_date(val) {
      this.endDateFormatted = this.formatDate(val)
    },
  },
  methods: {
    ...mapActions(['updateCurStartDate', 'updateCurEndDate', 'updateCurCrewId']),
    clear() {

    },
    formatDate(date) {
      if (!date) return null
      return moment(date).format('DD/MM/YYYY')
    },
    parseDate(date) {
      if (!date) return null
      return moment(date, ['DD/MM/YYYY']).format('YYYY-MM-DD')
    },
    onFileSelect($event) {
      console.log($event)
      console.log(this.file)
      if ($event) {
        let formData = new FormData();
        formData.append('file', this.file);
        axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
        axios.post(`${process.env.VUE_APP_API_URL}/train/tr/fileupload`, formData)
          .then(response => {
            console.log(response)
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    getPositions() {
      var p = {
        division: this.$route.query.division
      }
      console.log(p)
      this.menu1 = false
      this.menu2 = false,
      this.updateCurStartDate(moment(this.start_date).format("YYYY-MM-DD"))
      this.updateCurEndDate(moment(this.end_date).format("YYYY-MM-DD"))
      //      console.log(this.curDeviceId)
      this.isLoading = true
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/hog/hog_trains`, {
          params: p
        })
        .then(response => {
          console.log(response.data);
          this.positions = response.data
          this.isLoading = false
        })
        .catch(e => {
          this.errors.push(e)
          if (e.response.status === 401) {
            this.$router.push({
              name: 'Signin'
            })
          }
        })
    },

    onRowClick($event) {
      // //       console.log($event);
      // this.updateCurCrewId($event.name)
      // this.$router.push({
      //   name: 'TrainsReport',
      //   query: {
      //     crew_id: $event.name,
      //     start_date: this.start_date,
      //     end_date: this.end_date
      //   }
      // })
    },
    getFormattedTime(t) {
      if (t !== '--') {
        var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
        var testDateUtc = moment(lt);
        //  var localDate = moment(testDateUtc).local();
        return testDateUtc.format("HH:mm:ss")
      }
    },
    getFormattedTimeSec(t) {
      if (t < 0) {
        return '-' + moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      } else {
        return moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      }
    },
    getFormattedDate(t) {
      return moment(t).format("DD/MM/YYYY")
    },
    createCSV() {
      let csvContent = "data:text/csv;charset=utf-8,";
      var filename = 'hog-trains.csv'
      var ctr = []
      for(var i=0; i <this.positions.length; i++ ) {
        ctr.push({
          Division: this.positions[i]['division'],
          Depot: this.positions[i]['depot'],
          Train_No:  this.positions[i]['train_no'],
          "Train Name":  this.positions[i]['train_name'],
          Frequency: this.positions[i]['frequency'],
          Origination: this.positions[i]['start'],
          Destination: this.positions[i]['end'],
         })
      }
      
      //
      jsonexport(ctr,function(err, csv){
         if(err) return console.log(err);
         //console.log(csv);
         var blob = new Blob([csv], {
          type: "data:text/csv;charset=utf-8,"
         });
         saveAs(blob, filename);
        });
    },
    getColor(calories) {
      if (calories > 400) return 'red'
      else if (calories > 200) return 'orange'
      else return 'green'
    },
  }
}
</script>
